import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=6524cff0&scoped=true&"
var script = {}
import style0 from "./Features.vue?vue&type=style&index=0&id=6524cff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524cff0",
  null
  
)

export default component.exports